import { supabase } from "@/integrations/supabase/client";

export interface ContactPayload {
  name: string;
  email: string;
  phone?: string | null;
  interest: string;
  budget?: string | null;
  preferred_location?: string | null;
  message: string;
  source: string;
}

/**
 * Sends both the internal team notification and the submitter confirmation
 * via the Mailgun-backed `send-contact-notification` edge function.
 *
 * `id` is accepted for API compatibility with prior callers but is not used
 * by Mailgun (the function does not require an idempotency key).
 */
export async function sendContactEmails(_id: string, payload: ContactPayload) {
  const { error } = await supabase.functions.invoke("send-contact-notification", {
    body: payload,
  });
  if (error) {
    console.error("send-contact-notification failed", error);
  }
}
